import React, { useState, useEffect } from "react";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import { ReactComponent as CrossIcon } from "../../../../../assets/Icons/Universal/CloseBtnIcon.svg";
const AddPeriod = ({ index, program, addNewProgram, removeProgram }) => {
  const [inputsVal, setInputsVal] = useState(program);
  useEffect(() => {
    addNewProgram(inputsVal);
    // eslint-disable-next-line
  }, [inputsVal]);

  return (
    <div className="flex-row align-center justify-between g-1">
      <label htmlFor="">1. Period</label>
      <div className="flex-1 flex-row align-center justify-start g-05">
        {/* <div className="flex-col align-start justify-start g-05">
        <label htmlFor={`subjectType-${index}`} className="t-12 poppins">
          Subject Type
        </label>
        <input
          type={"text"}
          placeholder={"Enter Subject Type"}
          name={"subjectType"}
          value={inputsVal.subjectType}
          onChange={(e) =>
            setInputsVal({ ...inputsVal, subjectType: e.target.value })
          }
          className={`programSubjectAddInput`}
        />
      </div> */}
        <div className="flex">
          <DropDownInput
            label={"Subject"}
            type="select"
            name={"subject"}
            value={inputsVal.subjectType}
            placeholder={"Choose subject"}
            setFieldValue={(val) =>
              setInputsVal({ ...inputsVal, subjectType: val })
            }
            suggestionList={["Sub 1", "Sub 2"]}
          />
        </div>
        <div className="flex">
          <DropDownInput
            label={"Teacher"}
            type="select"
            name={"teacher"}
            value={inputsVal.teacher}
            placeholder={"Choose teacher name"}
            setFieldValue={(val) =>
              setInputsVal({ ...inputsVal, teacher: val })
            }
            suggestionList={["Teacher 1", "Teacher 2"]}
          />
        </div>
        <div className="flex">
          <DropDownInput
            label={"Start session"}
            type="select"
            name={"startTime"}
            value={inputsVal.startTime}
            placeholder={"Choose a time"}
            setFieldValue={(val) =>
              setInputsVal({ ...inputsVal, startTime: val })
            }
            suggestionList={["10:30 AM", "11:30 AM"]}
          />
        </div>

        <div className="flex">
          <DropDownInput
            label={"End session"}
            type="select"
            name={"endTime"}
            value={inputsVal.endTime}
            placeholder={"Choose a time"}
            setFieldValue={(val) =>
              setInputsVal({ ...inputsVal, endTime: val })
            }
            
            suggestionList={["11:30 AM", "12:30 AM"]}
          />
        </div>
      </div>
      <button
        type="button"
        className="transparentBtn flex align-center justify-center mt-1"
        style={{
          width: "1.5rem",
          height: "1.5rem",
          borderRadius: "50%",
          background: "var(--redColor)",
          padding: "5px",
        }}
        onClick={() => removeProgram(inputsVal)}
      >
        {/* <img src={CrossIcon} alt="" /> */}
        <CrossIcon className="w-full h-full" style={{ objectFit: "cover" }} />
      </button>
    </div>
  );
};

export default AddPeriod;
